var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: `${_vm.editData.nameCH}的销售目标`,
        visible: _vm.dialogVisible,
        width: "1160px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "opt" },
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "80px" },
                attrs: { size: "small" },
                on: { change: _vm.getList },
                model: {
                  value: _vm.year,
                  callback: function ($$v) {
                    _vm.year = $$v
                  },
                  expression: "year",
                },
              },
              _vm._l(_vm.getYear, function (item) {
                return _c("el-option", {
                  key: item,
                  attrs: { label: item, value: item },
                })
              }),
              1
            ),
            _c(
              "div",
              {
                staticClass: "add flex_c_c",
                on: {
                  click: function ($event) {
                    _vm.dialogVisible2 = true
                  },
                },
              },
              [
                _c("svg-icon", {
                  attrs: { className: "icon", iconClass: "add" },
                }),
                _vm._v("生成目标 "),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "data" },
          [
            _c("BaseTable", {
              attrs: {
                height: 607,
                tableData: _vm.tableData,
                loading: _vm.loading,
                isPager: false,
                border: true,
              },
              scopedSlots: _vm._u([
                {
                  key: "salesAmount",
                  fn: function (row) {
                    return [
                      _c("div", { staticClass: "panel" }, [
                        _c(
                          "div",
                          {
                            staticClass: "target",
                            class: {
                              success:
                                row.scope.salesAmount >=
                                row.scope.estimateSalesAmount,
                              error:
                                row.scope.salesAmount <
                                row.scope.estimateSalesAmount,
                            },
                          },
                          [
                            _c("div", { staticClass: "tips" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.scope.salesAmount >=
                                      row.scope.estimateSalesAmount
                                      ? "达成"
                                      : "未达成"
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("span", { staticClass: "num" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      row.scope.salesAmount,
                                      row.scope.estimateSalesAmount
                                    )
                                  ) +
                                  "% "
                              ),
                            ]),
                          ]
                        ),
                        _c("span", { staticClass: "value" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "value-success":
                                  row.scope.salesAmount >=
                                  row.scope.estimateSalesAmount,
                                "value-error":
                                  row.scope.salesAmount <
                                  row.scope.estimateSalesAmount,
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.scope.salesAmount.toFixed(2) || 0
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(
                            " / " + _vm._s(row.scope.estimateSalesAmount) + " "
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
                {
                  key: "customerCount",
                  fn: function (row) {
                    return [
                      _c("div", { staticClass: "panel" }, [
                        _c(
                          "div",
                          {
                            staticClass: "target",
                            class: {
                              success:
                                row.scope.customerCount >=
                                row.scope.estimateCustomerCount,
                              error:
                                row.scope.customerCount <
                                row.scope.estimateCustomerCount,
                            },
                          },
                          [
                            _c("div", { staticClass: "tips" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.scope.customerCount >=
                                      row.scope.estimateCustomerCount
                                      ? "达成"
                                      : "未达成"
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("span", { staticClass: "num" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      row.scope.customerCount,
                                      row.scope.estimateCustomerCount
                                    )
                                  ) +
                                  "% "
                              ),
                            ]),
                          ]
                        ),
                        _c("span", { staticClass: "value" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "value-success":
                                  row.scope.salesAmount >=
                                  row.scope.estimateCustomerCount,
                                "value-error":
                                  row.scope.customerCount <
                                  row.scope.estimateCustomerCount,
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(row.scope.customerCount || 0) + " "
                              ),
                            ]
                          ),
                          _vm._v(
                            " / " +
                              _vm._s(row.scope.estimateCustomerCount) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
                {
                  key: "opt",
                  fn: function (row) {
                    return [
                      _c("div", { staticClass: "table-opt" }, [
                        _vm.checkDate(row.scope.cycleEndDate)
                          ? _c("img", {
                              staticClass: "delete",
                              attrs: {
                                title: "修改",
                                src: require("@/assets/images/const/edit.png"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.editRow(row.scope)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm.checkDate(row.scope.cycleStartDate)
                          ? _c("img", {
                              staticClass: "delete",
                              attrs: {
                                title: "删除",
                                src: require("@/assets/images/const/delete.png"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteRow(row.scope)
                                },
                              },
                            })
                          : _vm._e(),
                        !_vm.checkDate(row.scope.cycleEndDate) &&
                        !_vm.checkDate(row.scope.cycleEndDate)
                          ? _c("span", [_vm._v("-")])
                          : _vm._e(),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c("div", { staticClass: "ok flex_c_c", on: { click: _vm.ok } }, [
            _vm._v("确 定"),
          ]),
        ]
      ),
      _c("EditSaleTagetDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible1,
          editData: _vm.rowData,
          year: _vm.year,
          salesUserId: _vm.editData.id,
        },
        on: { cancel: _vm.AddCancel, ok: _vm.addOk },
      }),
      _c("AddSaleTagetDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible2,
          salesUserId: _vm.editData.id,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
          ok: _vm.addOk,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }